/**
 * Returns the page title from the dataLayer.
 */

import { normalizeWhitespace } from "../stringHelpers";

export default () => {
    const data = window?.dataLayer?.[0] ?? {};
    return normalizeWhitespace(data.page_name) ?? "";
}